import { ErrorPage } from '@components/error/ErrorPage';

function Custom404() {
    return (
        <ErrorPage
            title='404 Error'
            imageSrc='/assets/404_illustration.png'
            message='The page you are looking for does not exist'
        />
    );
}

export default Custom404;
